// extracted by mini-css-extract-plugin
export default {"Stroke":"UncommittedChangesIcon_Stroke__7rhjw"};